export const APP_PHASES = Object.freeze({
  INITIALIZING: 'initializing',
  REDIRECTING: 'redirecting',
  PRODUCT: 'product',
  ASSOCIATION: 'association',
  ERROR: 'error',
});

export const INITIALIZATION_ACTIONS = Object.freeze({
  START: 'initialization/start',
  REDIRECT: 'initialization/redirect',
  PRODUCT_READY: 'initialization/productReady',
  ASSOCIATION_READY: 'initialization/associationReady',
  FAIL: 'initialization/fail',
});

export const initialState = {
  phase: APP_PHASES.INITIALIZING,
  watchData: null,
  businessData: null,
  generatedCode: null,
  status: null,
  correlationId: '',
  message: '',
  cardType: '',
};

export function reducer(state, action) {
  switch (action.type) {
    case INITIALIZATION_ACTIONS.START:
      return {
        ...initialState,
        cardType: action.payload?.cardType || '',
      };

    case INITIALIZATION_ACTIONS.REDIRECT:
      return {
        ...state,
        phase: APP_PHASES.REDIRECTING,
        cardType: action.payload?.cardType || state.cardType,
      };

    case INITIALIZATION_ACTIONS.PRODUCT_READY:
      return {
        ...state,
        phase: APP_PHASES.PRODUCT,
        watchData: action.payload?.watchData ?? null,
        businessData: action.payload?.businessData ?? null,
        generatedCode: null,
        status: action.payload?.status ?? 200,
        correlationId: action.payload?.correlationId || '',
        message: '',
      };

    case INITIALIZATION_ACTIONS.ASSOCIATION_READY:
      return {
        ...state,
        phase: APP_PHASES.ASSOCIATION,
        watchData: null,
        businessData: null,
        generatedCode: action.payload?.generatedCode ?? null,
        status: action.payload?.status ?? 200,
        correlationId: action.payload?.correlationId || '',
        message: '',
      };

    case INITIALIZATION_ACTIONS.FAIL:
      return {
        ...state,
        phase: APP_PHASES.ERROR,
        watchData: null,
        businessData: null,
        generatedCode: null,
        status: action.payload?.status ?? null,
        correlationId: action.payload?.correlationId || '',
        message: action.payload?.message || '',
      };

    default:
      return state;
  }
}

export const selectIsInitializing = (state) =>
  state.phase === APP_PHASES.INITIALIZING;

export const selectIsRedirecting = (state) =>
  state.phase === APP_PHASES.REDIRECTING;

export const selectIsProduct = (state) => state.phase === APP_PHASES.PRODUCT;

export const selectIsAssociation = (state) =>
  state.phase === APP_PHASES.ASSOCIATION;

export const selectIsError = (state) => state.phase === APP_PHASES.ERROR;
